/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';

const useDebounce = (value:string, delay:number) =>
{
	const [ debounceValue, setDebounceValue ] = useState(value);

	// console.log('-----------', value);

	useEffect(() =>
	{
		const handler = setTimeout(() =>
		{
			setDebounceValue(value);
		}, delay);

		return () => clearTimeout(handler);
	}, [ value, delay ]);

	return (
		debounceValue
	);
};

export default useDebounce;